/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { ScreenReaderOnly } from '../../../ScreenReaderOnly';
import { StyledTD, StyledTH } from '../styles';
const FooterCell = ({ column: { footerAriaLabel, getFooterProps, getHeaderProps, render, alignment, }, isHeader, }) => {
    const CellContent = footerAriaLabel ? (React.createElement(React.Fragment, null,
        React.createElement(ScreenReaderOnly, { as: "span" }, footerAriaLabel),
        React.createElement("span", { "aria-hidden": "true" }, render('Footer')))) : (render('Footer'));
    return isHeader ? (React.createElement(StyledTH, Object.assign({ alignment: alignment || 'center', isFooterCell: true }, getHeaderProps(), { scope: "row", isSortable: false, role: "rowheader" }), CellContent)) : (React.createElement(StyledTD, Object.assign({ alignment: alignment || 'center', isFooterCell: true }, getFooterProps()), CellContent));
};
export { FooterCell };
//# sourceMappingURL=FooterCell.js.map